module.exports = __webpack_public_path__ + "img/icon_next.b1077f6c.svg";